import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/common/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import ServiciosPage from "./pages/ServiciosPage";
import ComoFuncionaPage from "./pages/ComoFuncionaPage";
import SobrePage from "./pages/SobrePage";
import FAQPage from "./pages/FAQPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactoPage from "./pages/ContactoPage";
import RecursosPage from "./pages/RecursosPage";
import GuiaTransicionPage from "./pages/GuiaTransicionPage";
import AvisoLegalPage from "./pages/AvisoLegalPage";
import PrivacidadPage from "./pages/PrivacidadPage";
import CookiesPage from "./pages/CookiesPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          {/* Main pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios" element={<ServiciosPage />} />
          <Route path="/como-funciona" element={<ComoFuncionaPage />} />
          <Route path="/sobre-realimenta" element={<SobrePage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          
          {/* Blog */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          
          {/* Resources */}
          <Route path="/recursos" element={<RecursosPage />} />
          <Route path="/guia-transicion" element={<GuiaTransicionPage />} />
          
          {/* Legal */}
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/privacidad" element={<PrivacidadPage />} />
          <Route path="/politica-cookies" element={<CookiesPage />} />
          
          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
      
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#fff',
            border: '1px solid #C4CEB5',
            color: '#1A2E22',
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
